import { checkoutShippingCarrierServiceStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService";
import { css } from "styled-components";

checkoutShippingCarrierServiceStyles.deliveryDateGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        .react-datetime-picker__calendar.react-datetime-picker__calendar--open {
            z-index: 9 !important;
        }
    `,
};
